export default{
  app: {
    title: 'Registro Público de la Abogacía',
    short_title: 'RPA',
    institucion: 'MINISTERIO DE JUSTICIA Y TRANSPARENCIA INSTITUCIONAL'
  },
  rpa: {
    descripcion: 'La Unidad de Registro Público de la Abogacía, en el marco de la Ley N° 387 de 9 de julio de 2013, del Ejercicio de la Abogacía, su Decreto Supremo Reglamentario N° 1760 de 09 de octubre de 2013, así como el Decreto Supremo N°3463 de 19 de enero de 2018, que garantiza la asistencia en la Defensa Técnica, Gratuita y Especializada de Niños Niñas y Adolescentes Víctimas de Delitos de Violencia, se encarga principalmente de 4 áreas:'
  },
  ciudadania_digital: 'La Ley N° 1080 de 11 de julio de 2018, establece el acceso pleno y ejercicio de la ciudadania digital en el Estado Plurinacional de Bolivia. La ciudadania digital consiste en el ejercicio de derechos y deberes a través del uso de tecnologías de información y comunicación en la interacción de las personas con las entidades púbñicas y privadas que presten servicios públicos delegados por el Estado, de manera segura, confiable e ininterrumpida.',
  ley1173: 'La Ley N° 1173 de 03 de mayo del 2019, de Abreviación Procesal Penal y de Fortalecimiento de Lucha Integral contra la Violencia a Niñas, Niños, Adolecentes y Mujeres, establece como un medio de notificacion el realizado por comunicación electrónica a través del buzón de notificaciones de ciudadania digital.',
  registro_ciudadania: {
    paso0: 'Realiza tu pre-registro, haciendo un click en el botón que dice “REALIZA TU PRE REGISTRO AQUÍ”, y comienza a llenar tus datos paso a paso.',
    paso1: 'En caso de seleccionar la opción de validación presencial, apersónate a cualquiera de los puntos de validación habilitados a nivel nacional.',
    paso2: 'Requisitos:',
    paso3: 'Pasos:'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/index.js